import React from "react";
import { useNavigate } from "react-router-dom";
import "./SuccessPage.css";

function SuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="success-page">
      <div className="success-card">
        <svg
          className="success-pin"
          viewBox="0 0 88 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44 0C24.67 0 9 15.67 9 35C9 62 44 106 44 106C44 106 79 62 79 35C79 15.67 63.33 0 44 0Z"
            fill="#C84B2F"
          />
          <circle cx="44" cy="35" r="22" fill="#F7EDD5" stroke="#9E3820" strokeWidth="1.5" />
          <circle cx="44" cy="35" r="15.5" fill="#D4A96A" />
          <circle cx="44" cy="35" r="9" fill="#EDD9A0" />
          <circle cx="44" cy="35" r="5" fill="#F7EDD5" />
          <circle cx="34" cy="26" r="1.6" fill="#1E3D10" />
          <circle cx="54" cy="26" r="1.6" fill="#1E3D10" />
          <circle cx="29" cy="37" r="1.6" fill="#1E3D10" />
          <circle cx="59" cy="37" r="1.6" fill="#1E3D10" />
          <circle cx="36" cy="47" r="1.6" fill="#1E3D10" />
          <circle cx="52" cy="47" r="1.6" fill="#1E3D10" />
          <circle cx="44" cy="24" r="1.4" fill="#1E3D10" />
        </svg>

        <p className="success-eyebrow">Abonnement confirmé</p>
        <h1 className="success-title">
          Merci de vous abonner à<br />
          <span>Round Top</span>
        </h1>

        <p className="success-lead">
          Bienvenue chez Bagels Round Top! Votre abonnement est maintenant
          actif. Surveillez vos messages texte — vous recevrez une confirmation
          avant chaque livraison.
        </p>

        <div className="success-tips">
          <h3>Bon à savoir</h3>

          <div className="success-tip">
            <div className="success-tip-icon">1</div>
            <div>
              Pour sauter une livraison, textez{" "}
              <code>skip</code> au numéro de Bagels Round Top.
            </div>
          </div>

          <div className="success-tip">
            <div className="success-tip-icon">2</div>
            <div>
              Pour vous désabonner en tout temps, textez{" "}
              <code>désabonner</code>.
            </div>
          </div>

          <div className="success-tip">
            <div className="success-tip-icon">3</div>
            <div>
              Vos bagels sont emballés à l'azote — congelez-les à l'arrivée et
              utilisez-les au fur et à mesure du mois.
            </div>
          </div>
        </div>

        <button className="success-cta" onClick={() => navigate("/")}>
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}

export default SuccessPage;
